import { CrudStoreItem } from 'legacy/lut/classes/models/CrudStoreItem'

import { I2070Form } from 'clickNgo/models/crud/forms'
import { ICrudFetchOptions } from 'clickNgo/models/crud/utils'
import { CrudStore } from 'core/types/crudStore'
import Logger from 'core/utils/Logger'

import { mapFlagRecordDependencyFrom2070Form } from '../lib/mapping/mapFlagRecordDependencyFrom2070Form'
import type { FlagRecordDependency } from '../model/types'

const DEFAULT_FLAG_DEPENDENCY_PAGE_SIZE = 10000

const isFlagRecordDependency = (
  dependency: FlagRecordDependency | null
): dependency is FlagRecordDependency => Boolean(dependency)

export const fetchFlagDependencyRecords = (
  options?: ICrudFetchOptions
): Promise<FlagRecordDependency[]> => {
  const source = CrudStore.get<I2070Form>(CrudStoreItem.ToolsCodeRules, options?.cacheKey)

  source.setPaging(
    options?.paging || {
      page: 0,
      pageSize: DEFAULT_FLAG_DEPENDENCY_PAGE_SIZE,
    }
  )

  return source
    .fetch({
      force: options?.isForce,
      skipHierarchyFilter: options?.skipHierarchyFilter,
      skipTotal: options?.skipTotal,
      sort: options?.sort,
    })
    .then((data) => {
      if (!data?.items) {
        return []
      }

      return data.items.map(mapFlagRecordDependencyFrom2070Form).filter(isFlagRecordDependency)
    })
    .catch((error) => {
      Logger.error('Error fetching flag dependency records:', error)
      throw error
    })
}
